import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from "@material-ui/core/Box";
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { ApplicationState } from "../../redux/reducers";
import { EmbalajeState } from "../../redux/types/embalajeActionTypes";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { IEvent } from "../../interfaces/IEvent";
import NumberField from "../controls/NumberField";
import { initialMercancia } from "../../redux/reducers/mercanciaReducer";
import { IParametro } from "../../redux/types/parametroActionTypes";
import { enums } from "../../enums/enums";
import * as utility from "../../blocks/utility";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from "../controls/SubmitButton";
import { ICliente } from "../../entities/catalogos/ICliente";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Mercancia, IMercancia } from "../../entities/solicitudes/Mercancia";
import swal from 'sweetalert2';
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';
import { IGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { setGuiaMercancias, setGuiaWizard } from "../../redux/actions/guiaActions";

interface OwnProps {
    value: Mercancia[];
    siguienteTab: (mercancias: Mercancia[]) => void;
}

interface StateProps {
    cliente: ICliente;
    embalajes: EmbalajeState[];
    parametros: IParametro[];
    guiaWizard: IGuiaWizard;
}

interface DispatchProps {
    setGuiaWizard: typeof setGuiaWizard;
    setGuiaMercancias: typeof setGuiaMercancias;
}

type Props = OwnProps & StateProps & DispatchProps;

const MercanciaListaGuia = ({
    value,
    siguienteTab,
    cliente,
    embalajes,
    parametros,
    guiaWizard,
    setGuiaWizard,
    setGuiaMercancias
}: Props) => {
    const [mercancias, setMercancias] = useState<Mercancia[]>(value?.length ? value : [new Mercancia({ ...initialMercancia })]);
    const commonWidth = { width: "10%" };
    const metroPulgada = utility.getValorParametro(parametros, 'metroPulgada');
    let kiloLibra = utility.getValorParametro(parametros, 'kilogramoLibra');
    kiloLibra = parseFloat(Number(kiloLibra || 0).toFixed(4));
    const [valorNoEstibable, setValorNoEstibable] = useState(0);
    const [valorMinimoNoEstibable, setValorMinimoNoEstibable] = useState(0);
    const valorMinimoObject = parametros?.find(a => a.nombre === 'Valor mínimo peso unitario');
    const [vUnidades] = useState<any[]>(() => {
        const unidades = JSON.parse(localStorage.getItem("unidades") || "[]");
        return Array.isArray(unidades) ? unidades : [];
    });

    const unidadMedidaPesoId = guiaWizard.unidadMedidaPesoId || 0;
    const unidadMedidaLongitudId = guiaWizard.unidadMedidaLongitudId || 0;

    useEffect(() => {
        if (parametros?.length) {
            const p36 = parametros.find(s => s.id === 36);
            const p39 = parametros.find(s => s.id === 39);
            if (p36) setValorNoEstibable(Number(p36['valor']));
            if (p39) setValorMinimoNoEstibable(Number(p39['valor']));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setGuiaMercancias(mercancias.map(m => new Mercancia(m)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mercancias]);

    const pesoUnidades = (vUnidades || []).filter(u =>
        u.tipo_unidad_nombre?.toUpperCase() === "PESO"
    );
    const medidaUnidades = (vUnidades || []).filter(u =>
        u.tipo_unidad_nombre?.toUpperCase() === "MEDIDAS"
    );

    const handleTipoUnidad = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value: raw } = event.target;
        const nextValue = Number(raw);
        const prevLongitud = unidadMedidaLongitudId;

        setGuiaWizard({
            ...guiaWizard,
            [name]: nextValue
        } as IGuiaWizard);

        const copiaMercancias: Mercancia[] = [];
        mercancias.forEach(m => {
            const copiaMercancia = new Mercancia(m);
            copiaMercancia.ConvertirValores(name, nextValue, metroPulgada, kiloLibra);
            if (name !== "unidadMedidaLongitudId") {
                copiaMercancia.CalcularVolumen(prevLongitud, Number(metroPulgada));
            } else {
                copiaMercancia.CalcularVolumen(nextValue, Number(metroPulgada));
            }
            cambiarAlto(copiaMercancia, "alto", copiaMercancia.alto, name === "unidadMedidaLongitudId" ? nextValue : unidadMedidaLongitudId);
            copiaMercancias.push(copiaMercancia);
        });
        setMercancias(copiaMercancias);
    };

    const addMercancia = () => {
        const nuevaMercancia = new Mercancia({ ...initialMercancia });
        nuevaMercancia.id = Math.max(...mercancias.map(m => m.id || 0), 0) + 1;
        setMercancias([...mercancias, nuevaMercancia]);
    };

    const deleteMercancia = (id: number) => {
        setMercancias(mercancias.filter(m => m.id !== id));
    };

    const validarMedida = (mercancia: IMercancia, campo: string, valor: any, isLastValue: any): boolean => {
        if (!mercancia.camposParaValidar?.includes(campo) || (!valor && isLastValue === 0))
            return true;

        const embalaje = embalajes.find(e => e.id === mercancia.embalajeId);
        const embalajeCliente = cliente.embalajes?.find(e => e.id === mercancia.embalajeId);
        const valorEmbalaje = embalaje ? embalaje[campo] : 0;
        const valorEmbalajeCliente = embalajeCliente ? embalajeCliente[campo] : 0;
        let valorPermitido = valorEmbalajeCliente > valorEmbalaje ? valorEmbalajeCliente : valorEmbalaje;

        if (embalajeCliente === undefined || embalajeCliente === null)
            valorPermitido = valorEmbalaje;
        else
            valorPermitido = valorEmbalajeCliente;

        if (campo === "peso") {
            if (unidadMedidaPesoId === enums.unidadMedidaPeso.libras)
                valorPermitido *= kiloLibra;
        } else {
            if (unidadMedidaLongitudId === enums.unidadMedidaLongitud.pulgadas)
                valorPermitido *= metroPulgada;
        }

        const esValido = valorPermitido >= valor ? valor > 0 ? true : false : false;

        if (!esValido) {
            let campoLabel = campo;
            let EtiquetaEmbalaje = embalaje?.nombre;
            if (localStorage.getItem("idioma") === 'en-US') {
                switch (campo) {
                    case "alto": campoLabel = traducirLabel(14); break;
                    case "largo": campoLabel = traducirLabel(173); break;
                    case "ancho": campoLabel = traducirLabel(16); break;
                    case "peso": campoLabel = traducirLabel(229); break;
                }
                EtiquetaEmbalaje = embalaje?.etiquetaEmbalaje?.nombre;
            }

            const mensaje = traducirMessage(42).replace('####', campoLabel).replace('#####', EtiquetaEmbalaje).replace('#####', valorPermitido);
            swal.fire({
                titleText: traducirMessage(11),
                text: mensaje,
                type: 'error',
            });
            return false;
        }

        if (mercancia.alto != null && mercancia.ancho != null && mercancia.largo != null && !mercancia.volumen) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(329),
                type: 'warning',
            });
            return false;
        }

        return true;
    };

    const cambiarAlto = (mercancia: IMercancia, propiedad: string, value, longitudId = unidadMedidaLongitudId) => {
        if (propiedad !== "esEstibable" && propiedad !== "alto") return;

        const esEstibable = (propiedad === "esEstibable" && value) || mercancia.esEstibable;
        const factorConversion = longitudId === enums.unidadMedidaLongitud.pulgadas ? metroPulgada : 1;
        const valorMinimoNoEstibableConvert = valorMinimoNoEstibable * factorConversion;
        const valorDefault = valorNoEstibable * factorConversion;

        if (propiedad === "alto") {
            const mantenerAltoReal = esEstibable && !!mercancia.altoReal && mercancia.alto === valorDefault;
            mercancia.altoReal = mantenerAltoReal ? mercancia.altoReal : value;
        }

        if (esEstibable && Number(mercancia.alto) > valorMinimoNoEstibableConvert) {
            mercancia.alto = valorDefault;
            mercancia.altoReal = (mercancia.altoReal ?? 0) > valorDefault ? valorDefault : mercancia.altoReal;
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(150),
                type: 'warning',
            });
        }
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        const name = event.target.name || "";
        const value = name === "esEstibable" ? event.target.checked : event.target.value;
        const esCampoEmblaje = name === "embalajeId";
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, name, value, 0);

        copiaMercancia[name] = esValido ? value : null;
        copiaMercancia.LimpiarCampos(name);

        if (value === 0 && name === "cantidad") {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(132),
                type: 'warning',
            });
            copiaMercancia[name] = undefined;
            setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
            return;
        }

        if (!esCampoEmblaje || (value !== 0 && name === "embalajeId")) {
            if (esCampoEmblaje && (!value || Number(value) === 0)) {
                swal.fire({
                    titleText: traducirMessage(11),
                    text: traducirMessage(115),
                    type: 'warning',
                });
            }

            copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
            cambiarAlto(copiaMercancia, name, value);

            if (esCampoEmblaje) {
                const embalaje = embalajes.find(e => e.id === Number(copiaMercancia.embalajeId));
                copiaMercancia.embalaje = embalaje?.nombre;
                copiaMercancia.etiquetaEmbalaje = embalaje?.etiquetaEmbalaje;
                copiaMercancia.embalajeId = Number(value);
            }
        }

        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleBlur = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        if (valorMinimoObject !== undefined && valorMinimoObject !== null) {
            if (event.target.value !== undefined && event.target.value !== null && event.target.value !== "") {
                const copiaMercancia = new Mercancia(mercancia);
                const peso: number = Number(event?.target?.value ?? 0);
                const valorMinimoArray = String(valorMinimoObject["valor"]).split('|');
                const pesoMinimo = unidadMedidaPesoId === enums.unidadMedidaPeso.kilos
                    ? parseFloat(valorMinimoArray[0])
                    : parseFloat(valorMinimoArray[1]);
                const mensaje = traducirMessage(284) + pesoMinimo.toString();
                if (peso < pesoMinimo) {
                    swal.fire({
                        titleText: traducirMessage(11),
                        text: mensaje,
                        type: 'warning',
                    });
                    copiaMercancia.peso = null;
                    setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
                }
            }
        }
    };

    const handleAlto = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        if (!mercancia.embalajeId) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(115),
                type: 'warning',
            });
            return;
        }
        const value = event.target.value !== undefined ? event.target.value : null;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.alto = value !== null ? Number(value) : null;
        copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const validarAlto = (mercancia: Mercancia) => {
        if (!mercancia.alto) {
            if (mercancia.alto !== null ? (Number(mercancia.alto) > 0 ? true : false) : true)
                return;
        }
        const alto = mercancia.alto;
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, "alto", alto, 1);
        copiaMercancia.alto = esValido ? Number(alto) : null;
        if (esValido) {
            cambiarAlto(copiaMercancia, "alto", alto);
            copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
        }
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleLargo = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        if (!mercancia.embalajeId) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(115),
                type: 'warning',
            });
            return;
        }
        const value = event.target.value !== undefined ? event.target.value : null;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.largo = value !== null ? Number(value) : null;
        copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const validarLargo = (mercancia: Mercancia) => {
        if (!mercancia.largo) {
            if (mercancia.largo !== null ? (Number(mercancia.largo) > 0 ? true : false) : true)
                return;
        }
        const largo = mercancia.largo;
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, "largo", largo, 1);
        copiaMercancia.largo = esValido ? Number(largo) : null;
        if (esValido) {
            copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
        }
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleAncho = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        if (!mercancia.embalajeId) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(115),
                type: 'warning',
            });
            return;
        }
        const value = event.target.value !== undefined ? event.target.value : null;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.ancho = value !== null ? Number(value) : null;
        copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const validarAncho = (mercancia: Mercancia) => {
        if (!mercancia.ancho) {
            if (mercancia.ancho !== null ? (Number(mercancia.ancho) > 0 ? true : false) : true)
                return;
        }
        const ancho = mercancia.ancho;
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, "ancho", ancho, 1);
        copiaMercancia.ancho = esValido ? Number(ancho) : null;
        if (esValido) {
            copiaMercancia.CalcularVolumen(Number(unidadMedidaLongitudId), Number(metroPulgada));
        }
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleSiguienteTab = () => {
        let muestraError = 0;
        let muestraErrorVolumen = 0;

        mercancias.forEach(m => {
            if ((m.alto || m.ancho || m.largo) === 0) {
                muestraError++;
            }
            embalajes.forEach(e => {
                if (m.embalajeId === e.id && m.etiquetaEmbalaje === undefined) {
                    m.etiquetaEmbalaje = e.etiquetaEmbalaje;
                }
            });
            if (m.alto != null && m.ancho != null && m.largo != null && !m.volumen) {
                muestraErrorVolumen++;
            }
        });

        if (muestraError > 0) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(285),
                type: 'error',
            });
        } else if (muestraErrorVolumen > 0) {
            swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(329),
                type: 'warning',
            });
        } else {
            siguienteTab(mercancias);
        }
    };

    return (<>
        <Box display="flex">
            <Box pr={4} pb={3}>
                <FormLabel component="legend">{traducirLabel(308)}</FormLabel>
                <FormControl component="fieldset" id="unidadPesoGuia">
                    <RadioGroup
                        row
                        name="unidadMedidaPesoId"
                        value={unidadMedidaPesoId || ""}
                        onChange={handleTipoUnidad}
                    >
                        {pesoUnidades.map(u => (
                            <FormControlLabel
                                key={u.unidad_id}
                                value={u.unidad_id}
                                label={u.unidad_nombre}
                                control={<Radio color="primary" size="small" />}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Box>
            <Box pr={4} pb={3}>
                <FormLabel component="legend">{traducirLabel(307)}</FormLabel>
                <FormControl component="fieldset" id="unidadMedidaGuia">
                    <RadioGroup
                        row
                        name="unidadMedidaLongitudId"
                        value={unidadMedidaLongitudId || ""}
                        onChange={handleTipoUnidad}
                    >
                        {medidaUnidades.map(u => (
                            <FormControlLabel
                                key={u.unidad_id}
                                value={u.unidad_id}
                                label={u.unidad_nombre}
                                control={<Radio color="primary" size="small" />}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Box>
        </Box>

        <ValidatorForm onSubmit={handleSiguienteTab}>
            <TableContainer component={Paper}>
                <Table className="table-xs" size="small" aria-label="guia-mercancia-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(29)}</TableCell>
                            <TableCell align="center" style={{ width: "25%" }}>{traducirLabel(111)}</TableCell>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(14)}</TableCell>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(15)}</TableCell>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(173)}</TableCell>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(16)}</TableCell>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(229)}</TableCell>
                            <TableCell align="center" style={{ width: "11%" }}>{traducirLabel(320)}</TableCell>
                            <TableCell align="center" style={commonWidth}>{traducirLabel(190)}</TableCell>
                            <TableCell style={{ padding: 0, width: "4%" }} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mercancias.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>
                                    <TextValidator
                                        value={row.cantidad}
                                        name="cantidad"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 0, maxLength: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Select
                                        fullWidth
                                        name="embalajeId"
                                        value={row.embalajeId || 0}
                                        onChange={(e) => handleChange({
                                            target: {
                                                name: e.target.name,
                                                value: e.target.value
                                            }
                                        }, row)}
                                    >
                                        <MenuItem value={0} disabled />
                                        {localStorage.getItem("idioma") === 'en-US' && embalajes.map((e) => (
                                            <MenuItem key={e.id} value={e.id}>{e.etiquetaEmbalaje?.nombre}</MenuItem>
                                        ))}
                                        {localStorage.getItem("idioma") !== 'en-US' && embalajes.map((e) => (
                                            <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>
                                        ))}
                                    </Select>
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.alto}
                                        name="alto"
                                        onChange={(e) => handleAlto(e, row)}
                                        onBlur={() => validarAlto(row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.altoReal}
                                        name="altoReal"
                                        errorMessages={[""]}
                                        fullWidth
                                        disabled={true}
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.largo}
                                        name="largo"
                                        onChange={(e) => handleLargo(e, row)}
                                        onBlur={() => validarLargo(row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.ancho}
                                        name="ancho"
                                        onChange={(e) => handleAncho(e, row)}
                                        onBlur={() => validarAncho(row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.peso}
                                        name="peso"
                                        onChange={(e) => handleChange(e, row)}
                                        onBlur={(e) => handleBlur(e, row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.volumen}
                                        className="text-right"
                                        disabled={true}
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Checkbox
                                        checked={!!row.esEstibable}
                                        size="small"
                                        onChange={(e) => handleChange(e, row)}
                                        name="esEstibable"
                                        color="primary"
                                        className="check"
                                    />
                                </TableCell>
                                <TableCell style={{ padding: "0 5px 0 0" }}>
                                    {mercancias.length > 1 &&
                                        <DeleteIcon
                                            color="error"
                                            style={{ fontSize: "1rem" }}
                                            className="pointer"
                                            onClick={() => deleteMercancia(row.id)}
                                        />
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={2} className="text-right">
                <Button color="primary" size="small" startIcon={<AddCircleIcon />} onClick={addMercancia}>
                    {traducirLabel(8)}
                </Button>
            </Box>

            <SubmitButton label={traducirButton(15)} />
        </ValidatorForm>
    </>);
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    embalajes: state.embalajes,
    parametros: state.parametros,
    guiaWizard: state.guiaWizard
});

const mapDispatchToProps = {
    setGuiaWizard,
    setGuiaMercancias
};

export default connect(mapStateToProps, mapDispatchToProps)(MercanciaListaGuia);
